import { firestore, auth } from "../api/firebase";
import createDataContext from "./createDataContext";

const reviewsReducer = (state, action) => {
  switch (action.type) {
    case "set_reviews":
      return { ...state, reviews: action.payload };
    case "set_loading":
      return { ...state, loading: action.payload };
    case "set_daily_stat":
      return { ...state, daily: action.payload };
    case "set_monthly_stat":
      return { ...state, monthly: action.payload };
    case "set_historic_stat":
      return { ...state, historic: action.payload };
    default:
      return state;
  }
};

const ensureFreshAdminToken = async () => {
  try {
    const user = auth.currentUser;
    if (user) {
      await user.getIdToken(true);
    }
  } catch (_) {}
};

const fetchReviews = (dispatch) => async () => {
  dispatch({ type: "set_loading", payload: true });
  const reviewsFetch = [];

  const date = new Date();
  const lastMonth = new Date(date.getFullYear(), date.getMonth() - 1, 1);

  try {
    await ensureFreshAdminToken();
    const snapshot = await firestore
      .collection("reviews")
      .orderBy("timestamp", "desc")
      .where("timestamp", ">=", lastMonth)
      .get();

    snapshot.forEach((doc) => {
      reviewsFetch.push({ id: doc.id, ...doc.data() });
    });
    dispatch({ type: "set_reviews", payload: reviewsFetch });
  } catch (_) {
    // Evitar romper UI si el primer intento falla por token no fresco
  } finally {
    dispatch({ type: "set_loading", payload: false });
  }
};

const fetchIndicators = (dispatch) => async () => {
  try {
    await ensureFreshAdminToken();
    let response = await firestore.collection("stats").doc("daily").get();
    dispatch({ type: "set_daily_stat", payload: { ...response.data() } });

    response = await firestore.collection("stats").doc("monthly").get();
    dispatch({ type: "set_monthly_stat", payload: { ...response.data() } });

    response = await firestore.collection("stats").doc("historic").get();
    dispatch({ type: "set_historic_stat", payload: { ...response.data() } });
  } catch (_) {
    // Ignorar primer fallo por permisos si el token aún no refleja admin
  }
};

export const { Provider, Context } = createDataContext(
  reviewsReducer,
  { fetchReviews, fetchIndicators },
  {
    reviews: [],
    loading: false,
    daily: {},
    monthly: {},
    historic: {},
    validScopes: ["dia", "mes", "todo"],
  }
);
